import * as firebase from 'firebase'

var config = {
  apiKey: 'AIzaSyCtYWfZSjmmZ0jindNHz6GBJl3rDK1XCF8',
  authDomain: 'xinc-5cf8d.firebaseapp.com',
  databaseURL: 'https://xinc-5cf8d.firebaseio.com',
  storageBucket: 'xinc-5cf8d.appspot.com',
  messagingSenderId: '778786654543'
}

firebase.initializeApp(config)

var initializeAuth = function () {
  return new Promise(resolve => {
    firebase.auth().onAuthStateChanged(user => {
      authService.setUser(user)
      authService.loaded = true
      resolve(user)
    })
  })
}

var authService = {

  firebase: firebase,
  loaded: false,
  user: null,

  authenticated () {
    return this.loaded && this.user !== null && !this.user.isAnonymous
  },

  isLoaded () {
    return new Promise(function (resolve, reject) {
      initializeAuth().then(user => {
        resolve(user)
      })
    })
  },

  getToken () {
    if (this.loaded) {
      return this.user.getToken()
    } else {
      return null
    }
  },

  setUser (user) {
    this.user = user
    if (user !== null) {
      this.loaded = true
    } else {
      this.loaded = false
    }
  },

  login (email, password) {
    return this.firebase.auth().signInWithEmailAndPassword(email, password)
  },

  logout () {
    this.firebase.auth().signOut().then(() => {
      console.log('logout finished')
    })
  }
}

initializeAuth()

export default authService



// WEBPACK FOOTER //
// ./src/auth.js